import React from 'react'

interface PropertyListProps {
    items: any[]
}

export const PropertyList: React.FC<PropertyListProps> = (props): JSX.Element => {
    return <ul style={{margin: 0, padding: 0}}>
        {props.items.map((item, index) => {
            return <li style={{listStylePosition: "inside"}} key={index}>{item}</li>
        })}
    </ul>
}
